/**
 * SparkForm helper class. Used to set common properties on all forms.
 */
window.SparkForm = function (data) {
    const initialData = data;

    this.sparkFormId = 'abcdefghijklmnopqrstuvxz0123456789'
        .split('')
        .sort(() => 0.5 - Math.random())
        .slice(0, 10)
        .join('');

    Object.assign(this, data);

    /**
     * Create the form error helper instance.
     */
    this.errors = new SparkFormErrors();

    this.busy = false;
    this.successful = false;

    this.emitUpdated = () => {
        Bus.$emit(`sparkFormUpdated.${this.sparkFormId}`);
    };

    /**
     * Start processing the form.
     */
    this.startProcessing = function () {
        this.errors.forget();
        this.busy = true;
        this.successful = false;

        this.emitUpdated();
    };

    /**
     * Finish processing the form.
     */
    this.finishProcessing = function () {
        this.busy = false;
        this.successful = true;

        this.emitUpdated();
    };

    /**
     * Reset the form to its original state.
     */
    this.reset = function () {
        Object.assign(this, initialData);
        this.resetStatus();

        this.emitUpdated();
    };

    /**
     * Reset the errors and other state for the form.
     */
    this.resetStatus = function () {
        this.errors.forget();
        this.busy = false;
        this.successful = false;

        this.emitUpdated();
    };

    /**
     * Set the errors on the form.
     */
    this.setErrors = function (errors) {
        this.busy = false;
        this.errors.set(errors);

        this.emitUpdated();
    };
};
